import {StandbyListService as LegacyStandbyListService} from "app/services/standbyList/StandbyList.service";
import LoginActions, {LoginActionNames} from "app/actions/login.actions";
import { ApiSearchService } from "app/services/apiSearch/apiSearch.service";
import { Database, appValues } from "appRoot/app.constants";
import { UrlGeneratorService } from "external-services/url-generator-service/UrlGenerator.service";
import DateRangeBookingsService from "app/services/dateRangeBookings/dateRangeBookings.service";
import ViewActionsService from "app/actions/view.actions";
import NewBookingActionsService from "app/actions/newBooking.actions";
import ManagerActionsService from "app/actions/manager.actions";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import {AdminServiceLog, ApiStatus} from "app/app.types";
import PaymentService from "external-services/diary-payment-service";
import ForecastReportService from 'app/services/forecastReport/forecastReport.service';
import ErrorTracking from "app/services/errorTracking/errorTracking.service";
import ServiceGroupsService from "external-services/service-groups-service/serviceGroups.service";
import TrackingService from 'app/services/tracking/tracking.service';
import SearchService from "app/services/search/search.service";
import AccountService from 'app/services/account/account.service';
import TagsService from "external-services/tags-service/index";
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import StatusConfigService from "external-services/status-config-service/index";
import BackChannelService from 'app/services/backChannel/backChannel.service';
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import PhoneNumberService from "app/services/phoneNumber/phoneNumber.service";
import CustomerService from "app/services/customer/customer.service";
import CustomerOfflineService from "external-services/customer-offline-service/index";
import CustomerUpdateService from "external-services/customer-update-service/customerUpdate.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import SmsService from "external-services/sms-service/index";
import BookingService from "app/services/booking/booking.service";
import BookingUpdateService from "external-services/booking-update-service/index";
import VenueActions from "app/actions/venue.actions";
import PouchActions, {PouchLoadStatus} from "app/actions/pouch.actions";
import PouchLoadService from "external-services/pouch-load-service/index";
import LegacyRecurringBookingService from 'shared-services/recurring-booking-service/index';
import ExternalRecurringBookingService from 'external-services/recurring-booking-service/index';
import TelemetryService from "app/services/telemetry/telemetry.service";
import CustomerSearchService from "external-services/customer-search-service/index";
import CustomerNormaliseService from "external-services/customer-normalise-service/index";
import CustomerLookupService from 'external-services/customer-lookup-service/index';
import TableSelectionService from "external-services/table-selection-service/index";
import NetworkConnectionActions from "app/actions/networkConnection.actions";
import CustomerStateActions from "app/actions/customerState.actions";
import AppUtilsService from "app/services/utils/utils.service";
import LegacyRecurringTableSeaterService from "shared-services/recurring-booking-service/RecurringTableSeater.service";
import RecurringTableSeaterService from "external-services/recurring-booking-service/RecurringTableSeater.service";
import BookingChangeService from "external-services/booking-change-service/bookingChange.service";
import {BookingAvailabilityService as LegacyBookingAvailabilityService} from "app/services/LegacyBookingAvailabilityService";
import {BookingAvailabilityService} from "external-services/booking-availability-service/index";
import LocationService from "external-services/location-service";
import store from 'appRoot/Store';
import {loadStatus} from "shared-types/index";
import {settingActions} from "app/reducers/settings/slice";
import {loadStatuses} from 'app/reducers/status/slice';
import {loadSchedules} from "app/reducers/schedule/slice";
import {loadLayout} from 'app/reducers/layout/slice';
import BookingUpsellOptionsService from 'external-services/booking-upsell-options-service/bookingUpsellOptions.service';
import {pouchActions} from 'app/reducers/pouch/slice';
import {getAccountDetails} from "app/reducers/auth/slice";
import MainViewVisibilityService from "app/services/mainViewVisibility";
import OAuth2Service from 'external-services/oauth-login/OAuth2.service';
import {ToastActionClean} from 'app/actions/toast.actions';
import RouteChangeService from "app/services/routeChange/routeChange.service";

const NS = 'SetUpCtrl';

export default function SetUpCtrl(
  $log, $rootScope, $scope, $state, $stateParams, $mdDialog, $timeout, $http, $localStorage, $filter, $window, $mdToast, $q,
  pouchService, AuthService, tablesService,
  scheduleService,
  appURLS, ToastActions, AppEventService
) {
  "ngInject";

  var vm = this;

  var remoteDocTotal = null;
  var isSetUp = false;
  var isUptodateWithRemote = false;
  var serverCallFail = false;
  var completeState = 'bookings';
  var pouchChangeListener, pouchUpToDateListener, pouchInitialProgressListener;
  const timeInterval = Database.CouchSyncCheckFrequency;    // Used to define time interval between dbSync verifications [NBI-2294] - See Carlos

  //-- define public properties
  vm.loaderType = 'determinate';
  vm.progress = 0;
  vm.localStats = null;
  vm.lastStatus = "";
  vm.currentStatus = "";

  // set the complete page id
  if ($stateParams.completeState) {
    completeState = $stateParams.completeState;
  }

  // -- init
  vm.$onInit = () => {
    store.dispatch(settingActions.setAppLoadStatus(loadStatus.loading));
    AuthService.checkAuth().then((isAuth) => {
      if (isAuth) {
        console.log(NS, 'Logged In');
        initServices(AdminService.getVenue(), appURLS.API);
      } else {
        $rootScope.$on(LoginActionNames.APP_OPENED, () => {
          console.log('App Opened');
          initServices(AdminService.getVenue(), appURLS.API);
        });
      }
    });
    setUpDatabase();
  };


  function setUpDatabase() {
    remoteDocTotal = null;
    var venue = AdminService.getVenue();

    if (venue && !isNaN(venue.id) && venue.couchUrl) {

      PouchActions.setPouchLoadStatus(PouchLoadStatus.loading);
      store.dispatch(pouchActions.setPouchLoadStatus(PouchLoadStatus.loading));

      var account = AdminService.getAccount();

      store.dispatch(getAccountDetails({}));

      // Track user
      TrackingService.trackUser(account, venue);
      if (account && account.id) {
        ErrorTracking.setUserContext({
          name: venue.name,
          venueId: venue.id,
          accountId: account.id,
        });
      }

      // Guard sync of venue and couchUsers in $localStorage
      if ($localStorage.couchUsers && !$localStorage.couchUsers.couchUrl.endsWith(venue.couchName)) {
        $localStorage.couchUsers = null;
      }


      ($localStorage.couchUsers != null
        ? Promise.resolve($localStorage.couchUsers)
        : PouchLoadService.getCouchUsers(venue.id))
        .then(couchConfig =>
      {

        $localStorage.couchUsers = couchConfig;
        AdminService.setReducedCouchUrl(couchConfig.reducedCouchUrl);

        var urlTokens = couchConfig.reducedCouchUrl.split('/');
        var localName = urlTokens[urlTokens.length - 1];

        var fullInfo = {
          url: couchConfig.couchUrl,
          username: couchConfig.couchUsername,
          password: couchConfig.couchPassword
        };

        var reducedInfo = {
          url: couchConfig.reducedCouchUrl,
          username: couchConfig.reducedCouchUsername,
          password: couchConfig.reducedCouchPassword
        };

        // Sync listeners
        pouchInitialProgressListener = $rootScope.$on('pouch-initial-replica-change', function (event, args) {
          vm.progress = Math.max(0, Math.min(99, ((args.current / args.total) * 100)));
          console.log('Replica fetched', args.current, 'of', args.total, 'progress', vm.progress.toFixed(2) + '%');
          var statsMessage = 'Replica fetched' + args.current + 'of' + args.total + 'progress' + vm.progress.toFixed(2) + '%';
          AdminService.serverLoggingDbEvents(venue.id, "Create Database started inside : " + statsMessage , AdminServiceLog.INFOLOG, "");


          $scope.$digest();
        });
        pouchUpToDateListener = $rootScope.$on('uptodate-with-remote', uptodateWithRemote);
        pouchChangeListener = $rootScope.$on('db-change', dbChange);

        console.log("[setup db] - Create database started");
        AdminService.serverLoggingDbEvents(venue.id, "Create Database started", AdminServiceLog.INFOLOG, "DIARY VERSION: " + appValues.VERSION);

        console.log('*********_____executing createDatabase***********', venue.id);
        const currentVenueIdLoading = venue.id +'_' + LocationService.uuidv4();
        pouchService.setUniqueVenueID(currentVenueIdLoading); // this is passed into pouchService and saved as the current valid venue
        // create the database
        pouchService.createDatabase(localName, fullInfo, reducedInfo, venue.id, currentVenueIdLoading)
          .then(function (result) {
            // Logs into SEQ sucessfull database creation
            console.log("[setup] - Creating database result: " + result);
            AdminService.serverLoggingDbEvents(venue.id, "Database created successfully", AdminServiceLog.INFOLOG, "");

            // Guard offline
            $timeout(function () {
              if (!NetworkConnectionService.isOnline()) {
                checkSetUp();
              }
            }, 4000);

            // get the reduced database info
            pouchService.getRemoteDatebaseInfo(reducedInfo.url, reducedInfo.username, reducedInfo.password).then(function (remoteInfo) {
              if (remoteInfo && remoteInfo.data) {
                remoteDocTotal = remoteInfo.data.doc_count;
              }
              updateProgress();
              checkSetUp();
            }).catch(function (err) {
              console.log('**************ERRORRRRR******************')
              $log.error('Remote info fail - Reduced database', err);
              serverCallFail = true;
              checkSetUp();
            });

            // get the full database info
            pouchService.getRemoteDatebaseInfo(fullInfo.url, fullInfo.username, fullInfo.password).then(function () { }).catch(function (err) {
              serverCallFail = true;
              $log.error('Remote info fail - Full database', err);
            });
          })
        .catch(function (e) {
          $log.error('[setup] ==> Error creating a database', e);
          PouchActions.setPouchLoadStatus(PouchLoadStatus.failed);
          store.dispatch(pouchActions.setPouchLoadStatus(PouchLoadStatus.failed));

          // Logs into SEQ FAILED database creation
          AdminService.serverLoggingDbEvents(venue.id, "Database creation failed", AdminServiceLog.WARNLOG, e);

          const clearDataLink = 'https://kb.nowbookit.com/knowledge/how-to-clear-your-cache-in-google-chrome-laptop/desktop';

          var htmlContent = '';
          if (e && e.status !== 500) {
            htmlContent += `<p>Try to <a target="_blank" href="${clearDataLink}">clear website data</a> and then close all your tabs and windows before trying again.</p>`;
          }
          htmlContent += '<p>If error persists, please contact support.</p>';
          if (e && e.name === 'web_sql_went_bad') {
            htmlContent = '<p>Please close all browser tabs and windows, then open and try again.</p>';
            htmlContent += `<p>If error persists, <a target="_blank" href="${clearDataLink}">clear website data</a> first and repeat.</p>`;
          }
          var alert = $mdDialog.alert()
            .parent(angular.element(document.body))
            .title('Error creating database.')
            .htmlContent(htmlContent)
            .ariaLabel('Error')
            .ok('Ok');
          $mdDialog.show(alert);
          logout();
        });
      }, () => logout());
    } else {
      logout();
    }
  }
  function logout() {

    if (window.config.enableOAuth2 && OAuth2Service.getIsEnableOAuth()) {
      OAuth2Service.logout().finally(() => {
        OAuth2Service.removeStoredDataForOauth();
        AuthService.logout();
      });
    } else {
      AuthService.logout();
    }
  }
  function uptodateWithRemote() {
    isUptodateWithRemote = true;
    if (pouchUpToDateListener) {
      pouchUpToDateListener();
    }
    checkSetUp();
  }

  function clearListeners() {
    if (pouchChangeListener) {
      pouchChangeListener();
    }
    if (pouchUpToDateListener) {
      pouchUpToDateListener();
    }
    if (pouchInitialProgressListener) {
      pouchInitialProgressListener();
    }
  }

  function checkSetUp() {
    if (!isSetUp) {
      if (PouchLoadService.getDbLocal()) {
        // check that the local database has docs
        scheduleService.getAllDaySchedules().then(function (schedules) {
          // the app has synced with the remote couch
          if ((isUptodateWithRemote || !NetworkConnectionService.isOnline() || serverCallFail) && !isSetUp) {

            if (schedules && schedules.rows && schedules.rows.length >= 7) {
              // The venue has at least a schedule for every day of the week it has been set up
              isSetUp = true;
              clearListeners();
              setUpVenue();

              pouchService.created = true;
            } else {
              // The venue has not enough schedules go to the wizard
              clearListeners();
              $state.go('wizard');
            }
          }
          $rootScope.$broadcast('set-up-complete');
        });
      }
    }
  }

  function setUpVenue() {
    wizardSetups();

    // load redux
    store.dispatch(loadStatuses())
      .then(() => {
        return store.dispatch(loadSchedules());
      })
      .then(() => {
        return store.dispatch(loadLayout());
      })
      .then(() => {
        return scheduleService.addIdsToServices();
      }).then(() => {
    // StatusConfigService.init({
    //   standByList: AdminService.getVenue().standByList,
    //   trackEvent: (...args) => TrackingService.trackEvent(...args),
    //   LoginActions, VenueActions, PouchActions
    // }).then(() => {
    //   store.dispatch(loadStatuses());
    //   // for backward compatibilty add _id to services on start up
    //   return scheduleService.addIdsToServices();
    // })

      //  fix error where types were not added to tags
      return TagsService.addTypeToTags();
    }).then(() => {
      // add the now show tag if it has not been added
      // TagsService.checkNoShow(); // removed because isOnlineCustomersEnabled is always true
      // update VIP tags
      TagsService.updateVIPTag();
      // update the UNconfired Tag
      StatusConfigService.updateUnconfirmedStatus(AdminService.getVenue());
      tablesService.init();
      PouchActions.setPouchLoadStatus(PouchLoadStatus.success);
      store.dispatch(pouchActions.setPouchLoadStatus(PouchLoadStatus.success));
    }).catch(function (e) {
      $log.error(e);
    });
  }

  function dbChange(event, change) {
    if (change) {
      vm.loaclDocTotal = change.doc_count;
    }
    updateProgress(change);
  }

  function updateProgress() {
    // get local info
    if (PouchLoadService.getDbLocal()) {
      PouchLoadService.getDbLocal().info().then(function (info) {
        vm.loaclDocTotal = info.doc_count;
        if (vm.loaclDocTotal && remoteDocTotal) {
          vm.progress = vm.loaclDocTotal / (remoteDocTotal / 100);
          if (vm.progress > 5) {
            vm.loaderType = 'determinate';
          }
          $scope.$digest();
          if (Math.ceil(vm.progress) >= 100) {
            checkSetUp();
          }
        }
      }).catch(function (e) {
        $log.error(e);
      });
    }
  }

  // deliberately in 2 places to because of wizard initialization
  function wizardSetups() {
    /**
     * GeneralSettingsService.setup also gets called in diary.module.helpers `initServices`.
     * Needs to be called in wizardSetups due to new venue settings save issue.
     */
    GeneralSettingsService.init(LoginActions, VenueActions);

    CustomerService.setup();
    CustomerService.init().then(() => {

      store.dispatch(settingActions.setAppLoadStatus(loadStatus.loaded));
      return $state.go(completeState);
    });

    CustomerSearchService.init(
      () => AdminService.getVenue()
    );
  }

  function ngToastAction(msg, options) {
    if (options?.useBetterToast) {
      return ToastActionClean.showToast(msg, options?.type)
    }
    $mdToast.show(
      $mdToast.simple()
        .content(msg)
        .position('bottom right')
        .theme('saved')
        .hideDelay(3000)
    );
  }

  function initServices(venue, apiBase) {

    RouteChangeService.init($state);

    // set globals to singleton services
    StatusConfigService.changeVenueInfo(
      venue.enableNewFloorPlan,
      venue.timeZoneId
    );
    BookingUpdateService.setup(
      (booking) => AppEventService.emit('managePreAuth', booking, null),
      (msg, options) => ngToastAction(msg, options),
      (...args) => TrackingService.trackEvent(...args),
      (...args) => TelemetryService.track(...args),
      (...args) => NetworkConnectionActions.handleStatusChange(...args),
      (...args) => AppUtilsService.validateObject(...args),
      () => {
        const {statusOptions, fullStatusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
        return {statusOptions, fullStatusOptions};
      }
    );
    TableSelectionService.setup((...args) => BookingUpdateService.updateFromAnywhere(...args));
    LegacyStandbyListService.setup(apiBase, venue.accountId, venue.id);
    ApiSearchService.setup(apiBase,venue.id);
    UrlGeneratorService.setup(venue.accountId, venue.id, $window.config);
    // VersionActionsService.setup($rootScope);
    ViewActionsService.setup($rootScope);
    NewBookingActionsService.setup($rootScope);
    ManagerActionsService.setup($rootScope);
    NetworkConnectionService.setCouchurl(AdminService.getVenue().couchUrl);
    DateRangeBookingsService.setup(pouchService);
    PaymentService.setup(ToastActionClean);
    LegacyRecurringBookingService.setup(apiBase, () => venue.id);
    ExternalRecurringBookingService.setup(apiBase, () => venue.id);
    LegacyRecurringTableSeaterService.setup(LegacyBookingAvailabilityService);
    RecurringTableSeaterService.setup(BookingAvailabilityService);
    SearchService.setup(TrackingService, venue);
    ServiceGroupsService.setup(scheduleService, TrackingService);
    TagsService.init({ TrackingService, VenueActions, PouchActions, getVenueId: () => AdminService.getVenue().id, getIsManager: () => ManagerService.isManager });
    BackChannelService.setup($rootScope, ToastActionClean);
    BookingsAffectedService.setup(scheduleService);
    PhoneNumberService.setup();
    CustomerOfflineService.setup(pouchService);
    CustomerOfflineService.init((...args) => TelemetryService.track(...args));
    CustomerUpdateService.setup(() => CustomerService.isAPIChannel(), (...args) => TrackingService.trackEvent(...args), (payload) => CustomerStateActions.customerChangeUpdateAction(payload));
    CustomerNormaliseService.init(AdminService.getVenue());
    SmsService.setup(ToastActions, () => {
      const {statusOptions, fullStatusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      return {statusOptions, fullStatusOptions};
    }, (booking) => {
      $rootScope.$broadcast('edit-booking', null, booking);
    });
    CustomerLookupService.setVenueCustomersUrl(venue.id);
    CustomerLookupService.setAccountCustomersUrl(venue.accountId);
    BookingChangeService.setup(AdminService.getAccount(), () => AdminService.getVenue());

    MainViewVisibilityService.init(venue.enableNewFloorPlan, window.config.enableTimelineV2);

    wizardSetups();
  }
}
